import Service from './Service'

import {
  Container,
  SubTitle,
  LabelRow
} from './styles'

export default function ServiceList ({ services = [] }) {
  if (services.length === 0) return (
    <Container>
      <SubTitle>
        0 resultados
      </SubTitle>
    </Container>
  )

  return (
    <Container>
      <SubTitle>
        {services.length + ' ' + (services.length === 1 ? 'Resultado' : 'Resultados')}
      </SubTitle>
      <LabelRow>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Categoria</SubTitle>
        <SubTitle>Preço</SubTitle>
        <SubTitle>Status</SubTitle>
      </LabelRow>
      {services.map (service => (
        <Service key={service.id} data={service}/>
      ))}
    </Container>
  )
}
